// src/data/f2lData.js
export const f2lAlgorithms = [
  {
    id: 1,
    number: '01',
    image: 'img28.png',
    algorithm: `(R<span class="mainColor2">U'</span>R'U)y'(R'U2R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>)(R'UR)`,
    scramble: '01',
    categories: ['bothDown'],
  },
  {
    id: 2,
    number: '02',
    image: 'img34.png',
    algorithm: `(UR<span class="mainColor2">U'</span>R'<span class="mainColor2">U'</span>)y'(R'UR)`,
    scramble: "F'U'FU[SX]",
    categories: ['upAndDown'],
    tips: "Similar as case #3\nWhite sticker facing down\nAlign side stickers to be on the same layer and same color (in this case blue as in picture), then move edge piece away from corner [U], move corner piece up [R], corner back to previous position\n U R U' R'",
  },
  {
    id: 3,
    number: '03',
    image: 'img40.png',
    algorithm: `(R'<span class="mainColor3">F'</span>RU)(R<span class="mainColor2">U'</span>R'F)`,
    scramble: '03+U',
    scrambleClass: 'scramble_orange',
    categories: ['upAndDown'],
    tips: "Similar as case #2\nWhite sticker facing down\nAlign side stickers to be on the same layer and same color (in this case red as in picture), then move edge piece away from corner [U'], move corner piece up [L'], corner back to previous position\n y U' L' U L",
  },
  {
    id: 4,
    number: '04',
    image: 'img46.png',
    algorithm: `[SX](RU2R'<span class="mainColor3">U'</span>)(RUR')`,
    scramble: '08',
    scrambleClass: 'scramblok',
    categories: ['bothDown'],
  },
  {
    id: 5,
    number: '05',
    image: 'img52.png',
    algorithm: `(RF)U(R<span class="mainColor2">U'</span>R'<span class="mainColor3">F'</span>)(<span class="mainColor2">U'</span>R')`,
    scramble: '09',
    categories: ['bothDown'],
  },
  {
    id: 6,
    number: '06',
    image: 'img58.png',
    algorithm: `y'(R'<span class="mainColor2">U'</span>RU)(R'<span class="mainColor2">U'</span>R)`,
    scramble: '10',
    categories: ['upAndDown'],
    tips: "Similar as case #11\nSide sticker and upper sticker DON'T match. Rotate both pieces [L'] and then move corner away from edge\n y L' U' L",
  },
  {
    id: 7,
    number: '07',
    image: 'img23.png',
    algorithm: `(R<span class="mainColor2">U'</span>R'U)(R<span class="mainColor2">U'</span>R')`,
    scramble: '11',
    categories: ['upAndDown'],
    tips: "Similar as case #10\nSide sticker and upper sticker match. Just move white sticker to the top [R] and align colors\n R U' R",
  },
  {
    id: 8,
    number: '08',
    image: 'img29.png',
    algorithm: `(R<span class="mainColor2">U'</span>R'U)(R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>R'U)(R<span class="mainColor2">U'</span>R')`,
    scramble: '04',
    categories: ['bothDown'],
  },
  {
    id: 9,
    number: '09',
    image: 'img35.png',
    algorithm: 'RUF<br/>[SX]<br/><span class="mainColor3">F\'</span>R\'',
    scramble: '05',
    categories: ['bothDown'],
  },
  {
    id: 10,
    number: '10',
    image: 'img41.png',
    algorithm: `y'(R'UR<span class="mainColor2">U'</span>)(R'UR)`,
    scramble: '06',
    categories: ['upAndDown'],
    tips: "Similar as case #7\nHere side sticker and upper sticker match. Just move white sticker to the top [L'] and align colors\n y L' U L",
  },
  {
    id: 11,
    number: '11',
    image: 'img47.png',
    algorithm: "[SX](RUR')",
    scramble: '07',
    categories: ['upAndDown'],
    tips: "Similar as case #6\nSide sticker and upper sticker DON'T match. Rotate both pieces [R] and then move corner away from edge\n R U R'",
  },
  {
    id: 12,
    number: '12',
    image: 'img53.png',
    algorithm: "[SX]2(RUR')",
    scramble: '[SX]3',
    categories: ['upAndMid'],
  },
  {
    id: 13,
    number: '13',
    image: 'img59.png',
    algorithm: `(R<span class="mainColor2">U'</span>R'U)y'(R'UR)`,
    scramble: '23, 33',
    categories: ['upAndMid'],
  },
  {
    id: 14,
    number: '14',
    image: 'img24.png',
    algorithm: "y'(R'U2)[SX] R",
    scramble: "R' [URU'R'] U2 R",
    categories: ['bothUp', 'bothUpWhiteUpBlock'],
  },
  {
    id: 15,
    number: '15',
    image: 'img30.png',
    algorithm: `y'<span class="mainColor2">U'</span>(R'U2)(R<span class="mainColor2">U'</span>R'UR)`,
    scramble: "R'U' [SX] U'RU",
    categories: ['bothUp', 'bothUpWhiteUp'],
    tips: 'White sticker up!\nAlign edge blue sticker with blue layer. Rotate the edge away from where it suppose to go, and put the corner on top of the edge.',
  },
  {
    id: 16,
    number: '16',
    image: 'img36.png',
    algorithm: `y'(R'UR<span class="mainColor3">U'</span><span class="mainColor2">U'</span>)(R'<span class="mainColor2">U'</span>R)`,
    scramble: '16, 36',
    categories: ['bothUp', 'bothUpWhiteUp'],
    tips: 'White sticker up!\nAlign edge blue sticker with blue layer. Rotate the edge away from where it suppose to go, and put the corner on top of the edge.',
  },
  {
    id: 17,
    number: '17',
    image: 'img42.png',
    algorithm: `FU(R<span class="mainColor2">U'</span>R'<span class="mainColor3">F'</span>)(R<span class="mainColor2">U'</span>R')`,
    scramble: "RUR' F[SX]F'",
    categories: ['bothUp', 'bothUpWhiteUpBlock'],
  },
  {
    id: 18,
    number: '18',
    image: 'img48.png',
    algorithm: `U(R<span class="mainColor2">U'</span>R'<span class="mainColor2">U'</span>)(R<span class="mainColor2">U'</span>R'U)(R<span class="mainColor2">U'</span>R')`,
    scramble: "38<br/>[SX](RUR'U)[SX]",
    categories: ['bothUp', 'bothUpWhiteUpBlock'],
  },
  {
    id: 19,
    number: '19',
    image: 'img54.png',
    algorithm: `(R<span class="mainColor2">U'</span>R'U2)(RUR')`,
    scramble: '19, 29',
    categories: ['bothUp', 'bothUpWhiteUp'],
    tips: 'White sticker up!\nAlign edge red sticker with red layer. Rotate the edge away from where it suppose to go, and put the corner on top of the edge.',
  },
  {
    id: 20,
    number: '20',
    image: 'img60.png',
    algorithm: `U(R<span class="mainColor2">U'</span><span class="mainColor3">U'</span>)(R'UR<span class="mainColor2">U'</span>R')`,
    scramble: `[SX](R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>R')<span class="mainColor2">U'</span>`,
    categories: ['bothUp', 'bothUpWhiteUp'],
    tips: 'White sticker up!\nAlign edge red sticker with red layer. Rotate the edge away from where it suppose to go, and put the corner on top of the edge.',
  },
  {
    id: 21,
    number: '21',
    image: 'img25.png',
    algorithm: `(R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>)(R'<span class="mainColor2">U'</span>RUR')`,
    scramble: "RU'R'U RU2R'",
    categories: ['bothUp', 'bothUpWhiteUpBlock'],
  },
  {
    id: 22,
    number: '22',
    image: 'img31.png',
    algorithm: `<span class="mainColor2">U'</span>(R<span class="mainColor2">U'</span>R'U2)(R<span class="mainColor2">U'</span>R')`,
    scramble: '32',
    categories: ['bothUp', 'upAndMid'],
    tips: "Similar as case #32\nTwo red stickers match\nRotate white sticker so you can still see it [U'] and move the edge so you get oposite color on the top\n U' R U' R'",
  },
  {
    id: 23,
    number: '23',
    image: 'img37.png',
    algorithm: `<span class="mainColor2">U'</span>(RUR')y'(UR'<span class="mainColor2">U'</span>R)`,
    scramble: "F'U'FU RU'R'U2",
    categories: ['bothUp', 'upAndMid'],
    tips: "Similar as case #33\nStickers DON'T match\nRotate upper layer [U2] and then move edge piece in direction to be oposite color on the top (in this case red, since you need to have oposite colors on the top for easy insertion, like case #25)\n U2 R U' R'",
  },
  {
    id: 24,
    number: '24',
    image: 'img43.png',
    algorithm: `y'U(R'UR<span class="mainColor2">U'</span>)(R'<span class="mainColor2">U'</span>R)`,
    scramble: "y' R'U [SX] RU'",
    categories: ['bothUp', 'bothUpWhiteFront'],
  },
  {
    id: 25,
    number: '25',
    image: 'img49.png',
    algorithm: `y'(R'<span class="mainColor2">U'</span>R) or y (L' U' L)`,
    scramble: "y'(R'UR)",
    categories: ['bothUp', 'bothUpWhiteFront'],
    tips: 'Easiest case!\nSimilar as case #40.',
  },
  {
    id: 26,
    number: '26',
    image: 'img55.png',
    algorithm: `y'U(R'<span class="mainColor2">U'</span>R<span class="mainColor2">U'</span>)(R'<span class="mainColor2">U'</span>R)`,
    scramble: '24',
    additionalAlgorithm: `y'(R'UR<span class="mainColor2">U'</span>)(R'<span class="mainColor2">U'</span>R) U2`,
    categories: ['bothUp', 'bothUpWhiteFront'],
  },
  {
    id: 27,
    number: '27',
    image: 'img61.png',
    algorithm: `y'(R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>)(R'2<span class="mainColor2">U'</span>)(R2<span class="mainColor2">U'</span>R')`,
    scramble: "y' RUR2U<br/>R2U2R'",
    categories: ['bothUp', 'bothUpWhiteFront'],
  },
  {
    id: 28,
    number: '28',
    image: 'img26.png',
    algorithm: `(lU)(r<span class="mainColor2">U'</span>r<span class="mainColor2">&#8216;U'</span>)l'`,
    scramble:
      "37<br/>(R<span class=\"mainColor2\">U'</span>R'U2)y'(R'<span class=\"mainColor2\">U'</span>R)",
    categories: ['bothUp', 'bothUpWhiteFrontBlock'],
    tips: 'Worth to learn!\nIt is quite ofter in real solves.',
  },
  {
    id: 29,
    number: '29',
    image: 'img32.png',
    algorithm: `<span class="mainColor2">U'</span>(R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>)(R'U2)(R<span class="mainColor2">U'</span>R')`,
    scramble: "RUR'U2<br/>RU2R'U",
    categories: ['bothUp', 'bothUpWhiteFront'],
  },
  {
    id: 30,
    number: '30',
    image: 'img38.png',
    algorithm: `<span class="mainColor2">U'</span>[SX](R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>R')`,
    scramble:
      '18 <br/>(R<span class="mainColor2">U\'</span><span class="mainColor3">U\'</span>)(R\'UR<span class="mainColor2">U\'</span>R\')U',
    categories: ['bothUp', 'bothUpWhiteFront'],
  },
  {
    id: 31,
    number: '31',
    image: 'img44.png',
    algorithm: `UR<span class="mainColor2">U'</span>R'`,
    scramble: '[SX]',
    categories: ['bothUp', 'bothUpWhiteFrontBlock'],
    tips: 'Easiest case!\nSimilar as case #34.',
  },
  {
    id: 32,
    number: '32',
    image: 'img50.png',
    algorithm: `<span class="mainColor2">U'</span>(R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>R'U)(RUR')`,
    scramble: '22',
    categories: ['bothUp', 'upAndMid'],
    tips: "Similar as case #22\nTwo blue stickers match\nRotate white sticker so you can still see it [U] and move the edge so you get oposite color on the top [R]\n y U L' U L",
  },
  {
    id: 33,
    number: '33',
    image: 'img56.png',
    algorithm: `y'U(R'<span class="mainColor2">U'</span>R)<span class="mainColor">d'</span>(RUR')`,
    scramble: '13',
    categories: ['bothUp', 'upAndMid'],
    tips: "Similar as case #23\nStickers DON'T match\nRotate upper layer [U2] and then move edge piece in direction to be oposite color on the top (in this case blue, since you need to have oposite colors on the top for easy insertion, like case #40)\n U2 y L' U L",
  },
  {
    id: 34,
    number: '34',
    image: 'img62.png',
    algorithm: `y'<span class="mainColor2">U'</span>(R'UR)`,
    scramble: "F'U'FU",
    categories: ['bothUp', 'bothUpWhiteSide'],
    tips: 'Easiest case!\nSimilar as case #31.',
  },
  {
    id: 35,
    number: '35',
    image: 'img27.png',
    algorithm: `y'U(R'<span class="mainColor2">U'</span>R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>)(R'UR)`,
    scramble: '15, 35',
    categories: ['bothUp', 'bothUpWhiteSide'],
  },
  {
    id: 36,
    number: '36',
    image: 'img33.png',
    algorithm: `y'U(R'U2R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>)(R'UR)`,
    scramble: "y' R'U'R U2<br/>R' U2 RU'",
    categories: ['bothUp', 'bothUpWhiteSide'],
  },
  {
    id: 37,
    number: '37',
    image: 'img39.png',
    algorithm: `(R<span class="mainColor2">U'</span>R'U2)y'(R'<span class="mainColor2">U'</span>R)`,
    scramble: "F'UF<br/>U2 RUR'",
    categories: ['bothUp', 'bothUpWhiteSideBlock'],
  },
  {
    id: 38,
    number: '38',
    image: 'img45.png',
    algorithm: `(R<span class="mainColor2">U'</span>R'U)(R<span class="mainColor2">U'</span>R'U2)(R<span class="mainColor2">U'</span>R')`,
    scramble: "RUR' U2 [SX] RUR'",
    categories: ['bothUp', 'bothUpWhiteSideBlock'],
  },
  {
    id: 39,
    number: '39',
    image: 'img51.png',
    algorithm: `<span class="mainColor2">U'</span>(RUR'U)(RUR')`,
    scramble: "(R<span class=\"mainColor2\">U'</span>R'U)(RUR')U2",
    categories: ['bothUp', 'bothUpWhiteSide'],
  },
  {
    id: 40,
    number: '40',
    image: 'img57.png',
    algorithm: "(RUR')",
    scramble: "17, 31, 39 or RU'R'",
    categories: ['bothUp', 'bothUpWhiteSide'],
    tips: 'Easiest case!\nSimilar as case #25.',
  },
  {
    id: 41,
    number: '41',
    image: 'img63.png',
    algorithm: `U'(R<span class="mainColor2">U'</span>R'U)(RUR')`,
    scramble: "RU'R'U'<br/>RUR'U",
    categories: ['bothUp', 'bothUpWhiteSideBlock'],
  },
];

export const filterDefinitions = {
  all: { label: 'Show All', items: 'all' },
  bothDown: { label: 'Both down', items: [1, 4, 5, 8, 9] },
  upAndMid: { label: 'Up & Mid', items: [12, 13, 22, 23, 32, 33] },
  upAndDown: { label: 'Up & down', items: [2, 3, 6, 7, 10, 11] },
  bothUp: {
    label: 'Both up',
    items: [
      14, 15, 16, 17, 18, 19, 20, 21, 24, 25, 26, 27, 28, 29, 30, 31, 34, 35,
      36, 37, 38, 39, 40, 41,
    ],
  },
  bothUpWhiteUp: { label: 'Both up-White up', items: [15, 16, 19, 20] },
  bothUpWhiteFront: { label: 'Both up-White front', items: [25, 26, 29, 30] },
  bothUpWhiteSide: { label: 'Both up-White right', items: [35, 36, 39, 40] },
  bothUpWhiteUpBlock: { label: 'Up-White up(blc)', items: [14, 17, 18, 21] },
  bothUpWhiteFrontBlock: {
    label: 'Up-White front(blc)',
    items: [24, 27, 28, 31],
  },
  bothUpWhiteRightBlock: {
    label: 'Up-White right(blc)',
    items: [34, 37, 38, 41],
  },
};
